import React, { useEffect, useReducer } from "react";

import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";

import { constants } from "./PaymentExceptionConstants";

import KendoExcelExporterDirect from "../../../components/export/KendoExcelExporterDirect";
import CsvExportDirect from "../../../components/export/CsvExportDirect";

import { useFetchExportDetailsData } from "./hooks/useFetchExportDetailsData";

export default function PaymentExceptionDirectExport(props) {
  let {
    email,
    api,
    apiParams,
    apiType = "get",
    exportFileName,
    directExportIsProcessing,
    setDirectExportIsProcessing,
    directExportType,
    setIsDirectExportDataLoading,
  } = props;

  const {
    data: exportDetailsData,
    isLoading: isDirectExportDataLoading,
    isError: isDirectExportDataError,
  } = useFetchExportDetailsData(
    email,
    api,
    apiParams,
    apiType,
    directExportIsProcessing
  );

  function directExportReducer(directExportState, action) {
    let thisAction = action.type.toLowerCase();

    if (thisAction === "clear") {
      return null;
    }

    let thisExportData = null;
    if (action.payload.length > 0) {
      let exportColumns = [];
      let exportRows = [];
      let headerProps = constants.detailExportDetailsProps;

      let thisData = action.payload;   
      Object.keys(thisData[0]).forEach((key) => {
        exportColumns.push({
          title: headerProps[key].title,
          type: headerProps[key].type,
          accessor: key,
          showTotal: headerProps[key].showTotal || false,
          hidden: headerProps[key].hidden || false,
        });
      });

      thisData.forEach((item) => {
        exportRows.push(item);
      });

      //if no exportColumns or exportRows  return null
      if (!exportColumns || exportColumns.length === 0) return null;
      if (!exportRows || exportRows.length === 0) return null;
      exportColumns = exportColumns.filter((item) => item.hidden == false);
      thisExportData = {
        columns: exportColumns,
        rows: exportRows,
      };
    }


    return { ExportType: thisAction, ExportData: thisExportData };
  }

  const [directExportState, dispatchDirectExport] = useReducer(
    directExportReducer,
    null
  );

  //after excel report ios exported this function is called to set the export excel state back to false
  function DirectExportCompletedCallback() {
    dispatchDirectExport({ type: "clear" });
  }

  useEffect(() => {
    //Make sure to notofy the parent on the isDirectExportDataLoading loading state
    setIsDirectExportDataLoading(isDirectExportDataLoading);

    //if we are not processing the export, then return
    if (!directExportIsProcessing) return;

    // if the data is in loading state, then return
    if (isDirectExportDataLoading) return;

    //if there is an error, then return
    if (isDirectExportDataError) return;

    //make sure we have some data
    if (IsNullOrEmpty(exportDetailsData)) {
      alert("No data found for export");
    } else {
      //dispatch the export
      dispatchDirectExport({
        type: directExportType,
        payload: exportDetailsData,
      });
    }

    //turn off the processing
    setDirectExportIsProcessing(false);

    //
  }, [directExportIsProcessing, isDirectExportDataLoading]);

  function GetProcessedExportDataColumns(sourceColumns) {
    let columns = [];

    if (!sourceColumns) return columns;

    if (sourceColumns.length > 0) {
      columns = sourceColumns.map((value) => {
        let newObject = {
          field: value.accessor,
          title: value.title,
        };

        return newObject;
      });
    }
    return columns;
  }

  return (
    <React.Fragment>
      {directExportState && directExportState.ExportType == "excel" && (
        <KendoExcelExporterDirect
          data={directExportState.ExportData.rows}
          columns={GetProcessedExportDataColumns(
            directExportState.ExportData.columns
          )}
          exportCompletedCallback={DirectExportCompletedCallback}
          exportFileNamePrefix={exportFileName}
        ></KendoExcelExporterDirect>
      )}
      {directExportState && directExportState.ExportType == "csv" && (
        <CsvExportDirect
          columns={[]}
          rows={[]}
          custom={directExportState.ExportData}
          exportCompletedCallback={DirectExportCompletedCallback}
          exportFileNamePrefix={exportFileName}
        />
      )}
    </React.Fragment>
  );
}
